import { jsx as _jsx } from "react/jsx-runtime";
import ModalFooter from 'components/ModalFooter';
import { txt } from 'libs/i18n';
const getPrimaryButtonLabel = (activeTab, isReplacing) => {
    if (activeTab === 'select') {
        return undefined;
    }
    if (activeTab === 'edit') {
        return isReplacing ? txt('updateAndReplace') : txt('update');
    }
    return isReplacing ? txt('addAndReplace') : txt('add');
};
const SpeakerDialogFooter = ({ activeTab, onCancel, onRemoveOccurrence, form, submitState = 'idle', isReplacing, }) => {
    const primaryLabel = getPrimaryButtonLabel(activeTab, isReplacing);
    return (_jsx(ModalFooter, { onCancel: onCancel, leftButton: isReplacing && onRemoveOccurrence !== undefined
            ? {
                label: txt('removeOccurrence'),
                onClick: onRemoveOccurrence,
                danger: true,
                disabled: submitState === 'loading',
            }
            : undefined, loading: submitState === 'loading', form: form, children: primaryLabel }));
};
export default SpeakerDialogFooter;
